import { render, staticRenderFns } from "./profileBox.vue?vue&type=template&id=179f1be0&"
import script from "./profileBox.vue?vue&type=script&lang=js&"
export * from "./profileBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports